import { Button, ButtonProps, CircularProgress } from "@mui/material";
import React, { FC } from "react";
import { Link, LinkProps } from "react-router-dom";
import { classes } from "./custom-button.style";

export type CustomButtonProps = {
  isLoading?: boolean;
  buttonType: "primary" | "secondary" | "danger";
} & ButtonProps &
  Partial<Pick<LinkProps, "to">>;

export const CustomButton: FC<CustomButtonProps> = ({
  buttonType,
  children,
  to,
  isLoading,
  ...props
}) => {
  return (
    <Button
      disableElevation
      disableRipple
      disableFocusRipple
      disableTouchRipple
      disabled={isLoading}
      {...(to ? { LinkComponent: Link, to } : {})}
      {...props}
      className={isLoading ? "isLoading" : ""}
      sx={{
        ...classes.root,
        ...classes[buttonType],
        ...props.sx,
      }}
    >
      {isLoading ? <CircularProgress color="inherit" size={20} /> : children}
    </Button>
  );
};
